import { ReactElement, useState } from "react";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import { useDispatch, useSelector } from "react-redux";
import { toggleLeftPanel } from "../actions";
import logoDark from "../assets/logo-optimus-steel.png";
import logoLight from "../assets/logo-optimus-dark.png";
import { IState } from "../types";
import ThemeSelector from "./headerComponents/themeSelector";
import LanguageComponent from "./headerComponents/languageComponent";
import AvatarComponent from "./headerComponents/avatarComponent";
import NotificationComponent from "./headerComponents/notificationComponent";
import { getPalette } from "../configuration/configuration";
import { useMediaQuery, useTheme } from "@mui/material";
import SearchBoxComponent from "./headerComponents/searchBoxComponent";
import { breakpoints } from "../system/theme";
import CaptureScreen from "./headerComponents/captureScreen";
import FullScreen from "./headerComponents/fullScreen";

const Header = (): ReactElement => {
  const theme = useTheme();
  const dispatch = useDispatch<any>();
  const dataContext = useSelector((state: IState) => state.dataContext);
  const selected = useSelector((state: IState) => state.selectedNode);
  const [ expanded, setExpanded ] = useState(false);
  const matchSM = useMediaQuery(`(min-width:${breakpoints.sm}px)`);

  const onExpanded = (isExpanded: boolean) => {
    setExpanded(isExpanded);
  };

  return(
    <AppBar position="fixed" sx={{ background: getPalette()[theme.palette.mode].background }}>
      <Toolbar>
        {theme.palette.mode === "dark"
          ? <img src={logoDark} alt={"optimus-steel-logo"} style={{ height: "40px", width: "40px", marginRight: "1em" }}/>
          : <img src={logoLight} alt={"optimus-steel-logo"} style={{ height: "40px", width: "40px", marginRight: "1em" }}/>
        }

        { !expanded &&
          <div className="display-flex-column align-items-center" style={{ position: "absolute", left: 0, right: 0 }}>
            <strong className="header-title">{dataContext && dataContext.title}</strong>
            {selected && <strong className="subHeader-title">{selected?.name}</strong>}
          </div>
        }

        <IconButton onClick={() => dispatch(toggleLeftPanel())} edge="start">
          <MenuIcon />
        </IconButton>

        <SearchBoxComponent mobile={!matchSM} onExpanded={onExpanded}/>

        <div className="flex-grow-1" />

        {matchSM &&
          <>
            <LanguageComponent/>
            <NotificationComponent/>
            <ThemeSelector/>
            <CaptureScreen/>
            <FullScreen/>
          </>
        }
        <AvatarComponent />

        {/*<IconButton onClick={() => dispatch(toggleRightPanel())} edge="end">*/}
        {/*  <MenuIcon />*/}
        {/*</IconButton>*/}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
